export function hasLowerCase(str) {
  return /[a-z]/.test(str);
}

export function hasUpperCase(str) {
  return /[A-Z]/.test(str);
}

export function hasNumber(str) {
  return /\d/.test(str);
}

export function hasSpecialCharacter(str) {
  return !/^[A-Za-z0-9 ]+$/.test(str);
}

export function hasMinLength(str) {
  return str.length > 7;
}

export function passwordFormatValidator() {}

export function getPasswordFormatValidationStatus(value) {
  if (!value) {
    return {
      hasLowerCase: false,
      hasUpperCase: false,
      hasNumber: false,
      hasSpecialCharacter: false,
      hasMinLength: false,
    };
  }

  return {
    hasLowerCase: hasLowerCase(value),
    hasUpperCase: hasUpperCase(value),
    hasNumber: hasNumber(value),
    hasSpecialCharacter: hasSpecialCharacter(value),
    hasMinLength: hasMinLength(value),
  };
}

export function isValidEmailAddress(emailString) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return (
    !!emailString &&
    typeof emailString === 'string' &&
    emailString.match(emailRegex)
  );
}
